// App Configuration
const APP_CONFIG = {
  // Check if we're in admin mode
  isAdminMode: () => {
    const buildType = process.env.REACT_APP_BUILD_TYPE;
    const appMode = process.env.REACT_APP_APP_MODE;
    const pathname = window.location.pathname;
    const port = window.location.port;
    
    return buildType === 'admin' || 
           appMode === 'admin' ||
           port === '3001' ||
           window.location.hostname.includes('admin') ||
           pathname.startsWith('/admin');
  },
  
  // Get the base URL for API calls
  getApiUrl: () => {
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL;
    }
    
    // For admin mode, use admin-specific API URL if available
    if (APP_CONFIG.isAdminMode() && process.env.REACT_APP_ADMIN_API_URL) {
      return process.env.REACT_APP_ADMIN_API_URL;
    }
    
    // Default API URL
    return 'http://localhost:5000/api';
  },
  
  // Get the app title based on mode
  getAppTitle: () => {
    return APP_CONFIG.isAdminMode() ? 'Admin Dashboard - Visions Of Love' : 'Visions Of Love';
  },
  
  // Get the base path for routing
  getBasePath: () => {
    return '/';
  },
  
  // Get the base server URL (without /api) for images and media
  getBaseServerUrl: () => {
    const apiUrl = APP_CONFIG.getApiUrl();
    // Remove /api from the end if present
    if (apiUrl.endsWith('/api')) {
      return apiUrl.replace('/api', '');
    }
    // Handle /api/ in the middle
    if (apiUrl.includes('/api/')) {
      return apiUrl.replace('/api/', '/');
    }
    // Ensure no trailing slash
    return apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl.replace('/api', '');
  },
  
  // Get Stripe publishable key
  getStripePublishableKey: () => {
    return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
  }
};

export default APP_CONFIG;
